import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ScrollEngine from "./ScrollEngine";

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior }); }, [location.pathname, location.hash]);
  return null;
}

export default function Layout() {
  return <div className="site-shell"><ScrollEngine /><ScrollToTop /><Header /><main><Outlet /></main><Footer /></div>;
}
